import React, { useEffect, useRef } from "react";
import { useScroll } from "framer-motion";
import SeoLetter from "./SeoLetter"; // Adjust import path if needed
import "../../../../styles/styles.css";

const Seo = () => {
  const textRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: textRef,
    offset: ["start", "end 80%"],
  });

  // Lines of text to animate
  const lines = [
    "Every load. Every deal.",
    "Fair, fast, and directly between",
    "you and the driver.",
  ];

  // Observe only the button
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("slide-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (textRef.current) {
      const button = textRef.current.querySelector(".download-button");
      if (button) observer.observe(button);
    }

    return () => observer.disconnect();
  }, []);

  let letterIndex = 0;

  return (
    <div className="seo-container" ref={textRef}>
      <div className="seo-text-container">
        {lines.map((line, lineIdx) => (
          <div className="seo-line" key={lineIdx}>
            {[...line].map((letter, i) => {
              const index = letterIndex++;
              return (
                <SeoLetter
                  key={`${lineIdx}-${i}`}
                  letter={letter}
                  totalLetters={line.length}
                  index={index}
                  scrollYProgress={scrollYProgress}
                />
              );
            })}
          </div>
        ))}
      </div>
      <div className="download-button-container">
        <button className="download-button">Download App</button>
      </div>
    </div>
  );
};

export default Seo;
